export default "/images/vendor/flag-icon-css/flags/1x1/gp.svg?605c7dc7517a1cb0511d7b4c76136980";